import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getSortIndicator } from '@/lib/tableHelpers'
import { useTranslation } from 'react-i18next'

import ExpensesTableRow from './ExpensesTableRow'

export default function ExpensesTable({
	expensesData,
	loading,
	selectedExpenses,
	onSelectAll,
	onSelectExpense,
	isAllSelected,
	isIndeterminate,
	sortColumn,
	sortDirection,
	onSort,
}) {
	const { t } = useTranslation()
	const columns = [
		{ key: 'expenseName', label: t('expenses.list.table.expense'), sortable: true },
		{ key: 'expenseTotal', label: t('expenses.list.table.total'), sortable: true },
		{ key: 'forVat', label: t('expenses.list.table.vat'), sortable: false },
		{ key: 'forCorporateTax', label: t('expenses.list.table.corpTax'), sortable: false },
		{ key: 'tags', label: t('expenses.list.table.tags'), sortable: false },
		{ key: 'expenseDate', label: t('expenses.list.table.expenseDate'), sortable: true },
	]

	if (loading) {
		return <LoadingIndicator />
	}

	if (!expensesData || !expensesData.length) {
		return (
			<NoResultsIndicator
				message={t('expenses.list.emptyState.title')}
				description={t('expenses.list.emptyState.description')}
			/>
		)
	}

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left w-12">
							<input
								type="checkbox"
								checked={isAllSelected}
								ref={el => {
									if (el) el.indeterminate = isIndeterminate
								}}
								onChange={e => onSelectAll(e.target.checked)}
								className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
							/>
						</th>
						{columns.map(column => (
							<th key={column.key} className="py-2 px-4 border-b border-gray-300 text-left">
								{column.sortable ? (
									<button
										className="flex items-center font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
										onClick={() => onSort(column.key)}
									>
										{column.label}
										{getSortIndicator(column.key, sortColumn, sortDirection)}
									</button>
								) : (
									<span className="font-semibold text-gray-700">{column.label}</span>
								)}
							</th>
						))}
						<th className="py-2 px-4 border-b border-gray-300 text-right w-24">
							<span className="font-semibold text-gray-700">{t('expenses.list.table.actions')}</span>
						</th>
					</tr>
				</thead>
				<tbody>
					{expensesData.map(expense => (
						<ExpensesTableRow
							key={expense._id}
							expense={expense}
							isSelected={selectedExpenses.has(expense._id)}
							onSelectExpense={onSelectExpense}
						/>
					))}
				</tbody>
			</table>
		</div>
	)
}
